const paths = {
  listOperator: '/operator/list',
  editOperator: '/operator/edit'
};

export default paths;
